export const formActionWindowEvent = '__gef_apm_form__';
